import { render } from "./painel-layout.vue?vue&type=template&id=27d578a9"
import script from "./painel-layout.vue?vue&type=script&lang=js"
export * from "./painel-layout.vue?vue&type=script&lang=js"

import "./painel-layout.vue?vue&type=style&index=0&id=27d578a9&lang=scss"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__